/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_S5_Li3Inputs */

const en_guide_json_vs_yaml_xml_s5_li3 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S5_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use <strong>XML</strong> for: SOAP APIs, document markup, enterprise integrations, systems requiring strict schemas`)
};

const ko_guide_json_vs_yaml_xml_s5_li3 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S5_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>XML</strong> 사용: SOAP API, 문서 마크업, 엔터프라이즈 통합, 엄격한 스키마가 필요한 시스템`)
};

const ja_guide_json_vs_yaml_xml_s5_li3 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S5_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>XML</strong>の使用場面：SOAP API、ドキュメントマークアップ、エンタープライズ統合、厳密なスキーマが必要なシステム`)
};

/**
* | output |
* | --- |
* | "Use <strong>XML</strong> for: SOAP APIs, document markup, enterprise integrations, systems requiring strict schemas" |
*
* @param {Guide_Json_Vs_Yaml_Xml_S5_Li3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_s5_li3 = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_S5_Li3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_S5_Li3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_s5_li3(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_s5_li3(inputs)
	return ja_guide_json_vs_yaml_xml_s5_li3(inputs)
});